import SlsEmbalagClient from '@/api/SistemaDKP/sls-embalag.client';

const imagemHomeClient = new SlsEmbalagClient();
export default {
  namespaced: true,
  state: () => ({
    copyCurrentEsEmbalag: null,
    currentEsEmbalag: {
      id: null,
      cod_marca: null,
      caminho: null,
      caminho_catalogo: null,
      ordem_visualizacao: null,
      cor_cabecalho_marca: '#000000', // '#fff
      caminho_img_cabec_marcas: null,
      caminho_img_footer_principal: null,
      caminho_img_footer_secundaria: null,
    },
    embalagens: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'cdn_embalag',
      sortDesc: null,
    },
    optionsMarcas: [],
    isLoading: false,
  }),
  mutations: {
    setEsEmbalg(state, embalagens) {
      state.embalagens = embalagens;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setOptionsMarcas(state, payload) {
      state.optionsMarcas = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    addOfUpdateEsEmbalag(state, imagemHome) {
      const index = state.embalagens.findIndex((i) => i.log_img_id === imagemHome.log_img_id);
      if (index === -1) {
        state.embalagens.push(imagemHome);
      } else {
        state.embalagens[index] = imagemHome;
      }
    },
    setCurrentEsEmbalag(state, imagemHome) {
      state.copyCurrentEsEmbalag = { ...imagemHome };
      state.currentEsEmbalag = {
        ...imagemHome,
        caminho: null,
        caminho_catalogo: null,
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
    },
    deleteEsEmbalag(state, id) {
      const index = state.embalagens.findIndex((i) => i.log_img_id === id);
      state.embalagens.splice(index, 1);
    },
    resetCurrentEsEmbalag(state) {
      state.currentEsEmbalag = {
        id: null,
        cod_marca: null,
        caminho: null,
        caminho_catalogo: null,
        ordem_visualizacao: null,
        cor_cabecalho_marca: '#000000', // '#fff
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
      state.copyCurrentEsEmbalag = {
        id: null,
        cod_marca: null,
        caminho: null,
        caminho_catalogo: null,
        ordem_visualizacao: null,
        cor_cabecalho_marca: '#000000', // '#fff
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
    },
  },
  getters: {
    getEsEmbalg(state) {
      return state.embalagens.sort((a, b) => {
        if (a.ordem > b.ordem) {
          return 1;
        }
        if (a.ordem < b.ordem) {
          return -1;
        }
        return 0;
      });
    },
    getCurrentEsEmbalag(state) {
      return state.currentEsEmbalag;
    },
    getCopyCurrentEsEmbalag(state) {
      return state.copyCurrentEsEmbalag;
    },
    getFilters(state) {
      return state.filters;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    getOptionsMarcas(state) {
      state.optionsMarcas.push({ cod_marca: null, des_marca: 'Selecione uma marca' });
      return state.optionsMarcas
        .sort((a, b) => {
          if (a.des_marca === 'Selecione uma marca') {
            return -1;
          }
          if (a.cod_marca > b.cod_marca) {
            return -1;
          }
          if (a.cod_marca < b.cod_marca) {
            return 1;
          }
          return 0;
        })
        .map((m) => ({ text: m.des_marca, value: m.cod_marca }));
    },
    getIsAlteracao(state) {
      return JSON.stringify(state.currentEsEmbalag) !== JSON.stringify(state.copyCurrentEsEmbalag);
    },
  },
  actions: {
    async findAll(ctx, queryParams, options) {
      const { data, ...paginations } = await imagemHomeClient.getEsEmbalag(queryParams);
      ctx.commit('setEsEmbalg', data);
      ctx.commit('setFilters', {
        ...ctx.getters.getFilters,
        page: paginations.page,
        perPage: paginations.perPage,
      });
      return Promise.resolve({
        data,
        paginations,
      });
    },
  },
};
